import script from "./CardImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardImage.vue?vue&type=script&setup=true&lang=ts"

import "./CardImage.vue?vue&type=style&index=0&id=92532db0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92532db0"]])

export default __exports__